import React from 'react';

import { ArtworkGridContainer, NoResults, Spaced, Tab, forResource } from '../common/container/Container.jsx';
import { Artist as ArtistCell, Artwork as ArtworkCell, ShowVertical } from '../common/container/Cell.jsx';
import { Indicator as LoadingIndicator } from '../common/container/Loading.jsx';
import { ListArtworkAdd } from '../common/container/Popup.jsx';
import { Follow as FollowButton } from '../common/input/Button.jsx';

let _ShowInst;
class _Show extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            artwork: {
                dir: 1,
                limit: 20,
                loading: false,
                offset: 0,
                order: 2
            },
            artists: {
                loading: true
            },
            relatedShows: {
                loading: true
            }
        };

        this.configureTabs = this.configureTabs.bind(this);
        this.getArtistDetail = this.getArtistDetail.bind(this);
        this.getArtists = this.getArtists.bind(this);
        this.getArtwork = this.getArtwork.bind(this);
        this.getRelatedShows = this.getRelatedShows.bind(this);
        this.handleArtistFollowChange = this.handleArtistFollowChange.bind(this);
        this.handleArtworkLikeChange = this.handleArtworkLikeChange.bind(this);
        this.handleArtworkWaypointEnter = this.handleArtworkWaypointEnter.bind(this);
        this.handleListArtworkAddModalClose = this.handleListArtworkAddModalClose.bind(this);
    }

    componentDidMount() {
        _ShowInst = true;

        const component = this;
        component.props.onRegisterRequestCallback(function (responseData) {
            // Artcloud.mkt._helpers.readall(responseData, responseData.About, 300);

            const id = responseData.ShowId;
            component.getArtists(id);
            component.getArtwork(id);
            component.getRelatedShows(id);
        });
    }

    componentWillUnmount() {
        _ShowInst = undefined;

        if (this.artistDetailRequest) {
            this.artistDetailRequest.abort();
            this.artistDetailRequest = null;
        }
        if (this.artistsRequest) {
            this.artistsRequest.abort();
            this.artistsRequest = null;
        }
        if (this.artworkRequest) {
            this.artworkRequest.abort();
            this.artworkRequest = null;
        }
        if (this.relatedShowsRequest) {
            this.relatedShowsRequest.abort();
            this.relatedShowsRequest = null;
        }
    }

    configureTabs() {
        const tabs = [{ active: true, label: 'Artwork', tab: 'artwork' }];
        if (this.props.data) {
            if (this.props.data.About && this.props.data.About.length) {
                tabs.push({ label: 'Press Release', tab: 'press-release' });
            }
            if (this.state.artists && this.state.artists.data) {
                tabs.push({ label: 'Artist' + (this.state.artists.data.length > 1 ? 's' : ''), tab: 'artists' });
            }
            if (this.props.data.Type != 3) {
                tabs.push({ label: 'Related Shows', tab: 'related-shows' });
            }
        }
        this.props.onConfigureTabs(tabs, 'artwork');
    }

    getArtistDetail(d) {
        const component = this;
        component.artistDetailRequest = Artcloud.api.get(
            Artcloud.url.vendor.marketplace.artists.getid(d.ArtistId),
            null,
            function (responseData) {
                component.artistDetailRequest = null;

                const state = component.state.artists;
                let artist = state.data[0];
                artist.Bio = responseData.Bio;
                if (responseData.Image) {
                    artist.ImgSrc = Artcloud.cdn.url(responseData.Image.S3Id, 260, 200, 'c_fill');
                }
                Artcloud.mkt.artists._isfollowing(artist);

                component.setState({
                    artists: state
                });
            },
            function (jqXHR, textStatus) {
                component.artistDetailRequest = null;
                Artcloud.api.fail(jqXHR, textStatus);
            }
        );
    }

    getArtists(showId) {
        const component = this;
        component.artistsRequest = Artcloud.api.get(
            Artcloud.url.vendor.marketplace.shows.artists.get(showId),
            null,
            function (responseData) {
                component.artistsRequest = null;

                if (responseData.Artists.length == 1) {
                    component.getArtistDetail(responseData.Artists[0]);
                } else {
                    responseData.Artists.forEach(function (d) {
                        Artcloud.mkt.artists._isfollowing(d);

                        if (!d.Image) {
                            return;
                        }
                        d.Height = 200;
                        d.Width = 260;
                        d.ImgSrc = Artcloud.cdn.url(d.Image.S3Id, d.Width, d.Height, 'c_fill');
                    });
                }
                component.setState({
                    artists: {
                        data: responseData.Artists
                    }
                }, function () {
                    component.configureTabs();
                })
            },
            function (jqXHR, textStatus) {
                component.artistsRequest = null;

                component.setState({
                    artists: {
                        data: []
                    }
                })
                Artcloud.api.fail(jqXHR, textStatus);
            }
        )
    }

    getArtwork(showId) {
        const component = this;
        const state = component.state.artwork;
        if (state.loading) {
            return;
        }
        state.loading = true;
        component.setState({
            artwork: state
        });
        component.artworkRequest = Artcloud.api.get(
            Artcloud.url.vendor.marketplace.shows.art.get(showId),
            { dir: state.dir, limit: state.limit, offset: state.offset, order: state.order },
            function (responseData) {
                component.artworkRequest = null;

                responseData.Art.forEach(function (d) {
                    Artcloud.mkt.art._isfavorite(d);
                });
                let data = state.data || [];
                state.data = data.concat(responseData.Art);

                state.offset += responseData.Art.length;
                state.total = responseData.Total;

                state.loading = false;
                component.setState({
                    artwork: state
                });
            },
            function (jqXHR, textStatus) {
                component.artworkRequest = null;

                state.loading = false;
                component.setState({
                    artwork: state
                });

                Artcloud.api.fail(jqXHR, textStatus);
            }
        );
    }

    getRelatedShows(showId) {
        const component = this;
        if (component.props.data && component.props.data.Type == 3) {
            return;
        }
        component.relatedShowsRequest = Artcloud.api.get(
            Artcloud.url.vendor.marketplace.shows.related.get(showId),
            null,
            function (responseData) {
                component.relatedShowsRequest = null;

                responseData.Shows.forEach(function (d) {
                    if (!d.Image) {
                        return;
                    }
                    d.ImgSrc = Artcloud.cdn.url(d.Image.S3Id, 260, 200, 'c_fill');
                });
                component.setState({
                    relatedShows: {
                        data: responseData.Shows
                    }
                });
            },
            function (jqXHR, textStatus) {
                component.relatedShowsRequest = null;

                component.setState({
                    relatedShows: {
                        data: []
                    }
                });
                Artcloud.api.fail(jqXHR, textStatus);
            }
        );
    }

    handleArtistFollowChange(d) {
        const state = this.state.artists;
        let artist;
        for (let i = 0; i < state.data.length; i++) {
            let temp = state.data[i];
            if (!temp || temp.ArtistId != d.ArtistId) {
                continue;
            }
            artist = temp;
            break;
        }
        if (!artist) {
            return;
        }
        const component = this;
        Artcloud.mkt.artists.updateFollowing(artist.ArtistId, !artist.IsFollowing, artist.Name, function (success) {
            if (success != true || !_ShowInst) {
                return;
            }
            artist.IsFollowing = !artist.IsFollowing;
            component.setState({
                artists: state
            });
        });
    }

    handleArtworkLikeChange(d) {
        const state = this.state.artwork;
        let artwork;
        for (let i = 0; i < state.data.length; i++) {
            let temp = state.data[i];
            if (!temp || temp.ArtId != d.ArtId) {
                continue;
            }
            artwork = temp;
            break;
        }
        if (!artwork) {
            return;
        }
        const component = this;
        Artcloud.mkt.art.updateFavorite(artwork.ArtId, !artwork.IsFavorite, artwork.Title, function () {
            if (!_ShowInst) {
                return;
            }
            artwork.IsFavorite = !artwork.IsFavorite;
            component.setState({
                artwork: state,
                listArtworkAddModal: {
                    data: artwork,
                    visible: true
                }
            });
        });
    }

    handleArtworkWaypointEnter() {
        if (!this.state.artwork.data || (this.state.artwork.data && this.state.artwork.offset >= this.state.artwork.total)) {
            return;
        }
        this.getArtwork(this.props.data.ShowId);
    }

    handleListArtworkAddModalClose() {
        this.setState({
            listArtworkAddModal: undefined
        });
    }

    render() {
        const data = this.props.data || {};
        let imageStyle;
        if (data.Image) {
            imageStyle = { backgroundImage: `url('${data.Image.Url}')` };
        }
        let artworkStyle;
        let className = 'tabs__content tabs__content__active spacer--bottom';
        if (this.props.tab == 'artwork') {
            className += ' section--masonry';
        } else {
            artworkStyle = { display: 'none' };
        }
        return (
            <React.Fragment>
                <Spaced className="cover__container cover--show section">
                    {data.Image && <div className="cover__img" style={imageStyle} />}
                    <div className="cover__content">
                        <div className="cover__name">
                            <h1>{data.Title}</h1>
                            <div className="cover__date">{data.Date}</div>
                            {
                                data.Gallery &&
                                <div className="cover__label">Presented by: <strong><a href={`/gallery/${data.Gallery.Slug}`}>{data.Gallery.Company}</a></strong></div>
                            }
                        </div>
                    </div>
                </Spaced>
                <Tab tabs={this.props.tabs} onClick={this.props.onTabClick} />
                <Spaced className={className}>
                    {
                        this.props.tab == 'artwork' &&
                        <React.Fragment>
                            {
                                !this.props.data &&
                                <LoadingIndicator />
                            }
                            {
                                this.state.artwork &&
                                <div style={artworkStyle}>
                                    {
                                        this.state.artwork.data &&
                                        this.state.artwork.data.length == 0 &&
                                        <NoResults display="No Artwork" />
                                    }
                                    <ArtworkGridContainer id="art" sizeClassName="art__container grid--3" onWaypointEnter={this.handleArtworkWaypointEnter}>
                                        {
                                            this.state.artwork.data &&
                                            this.state.artwork.data.length > 0 &&
                                            this.state.artwork.data.map((d) => <ArtworkCell key={d.ArtId} className="grid--3" d={d} sizingContainerId="sizing" onLikeChange={this.handleArtworkLikeChange} cols={4} />)
                                        }
                                    </ArtworkGridContainer>
                                    {
                                        this.state.artwork.loading &&
                                        <LoadingIndicator />
                                    }
                                </div>
                            }
                        </React.Fragment>
                    }
                    {
                        this.props.tab == 'press-release' &&
                        <div className="grid grid--12">
                            <p className="text--details">
                                <span className="less" style={{ display: 'block' }} dangerouslySetInnerHTML={{__html: data.About}}></span>
                            </p>
                        </div>
                    }
                    {
                        this.props.tab == 'artists' &&
                        <React.Fragment>
                            {
                                this.state.artists.loading &&
                                <LoadingIndicator />
                            }
                            {
                                this.state.artists.data &&
                                <React.Fragment>
                                    {
                                        this.state.artists.data.length == 0 &&
                                        <NoResults display="No Artists" />
                                    }
                                    {
                                        this.state.artists.data.length == 1 &&
                                        <ArtistDetail d={this.state.artists.data[0]} onFollowChange={this.handleArtistFollowChange} />
                                    }
                                    {
                                        this.state.artists.data.length > 1 &&
                                        <div className="container--spaced artist__grid__cont">
                                            {this.state.artists.data.map((d) => <ArtistCell key={d.ArtistId} d={d} onFollowChange={this.handleArtistFollowChange} type="fill" />)}
                                        </div>
                                    }
                                </React.Fragment>
                            }
                        </React.Fragment>
                    }
                    {
                        this.props.tab == 'related-shows' &&
                        <React.Fragment>
                            {
                                this.state.relatedShows.loading &&
                                <LoadingIndicator />
                            }
                            {
                                this.state.relatedShows.data &&
                                <React.Fragment>
                                    {
                                        this.state.relatedShows.data.length == 0 &&
                                        <NoResults display="No Related Shows" />
                                    }
                                    {this.state.relatedShows.data.map((d) => <ShowCell key={d.ShowId} d={d} />)}
                                </React.Fragment>
                            }
                        </React.Fragment>
                    }
                </Spaced>
                {
                    this.state.listArtworkAddModal &&
                    this.state.listArtworkAddModal.visible &&
                    <ListArtworkAdd data={this.state.listArtworkAddModal.data} onClose={this.handleListArtworkAddModalClose} />
                }
            </React.Fragment>
        );
    }
}

function ArtistDetail(props) {
    const data = props.d || {};
    let link;
    if (data.Slug) {
        link = `/artist/${data.Slug}`;
    }
    return (
        <React.Fragment>
            {
                data.ImgSrc &&
                <div className="grid grid--4">
                    <div className="artist__container">
                        <a href={link} style={{ color: 'initial' }}>
                            <img className="artist__img" src={data.ImgSrc} alt={data.Name} />
                        </a>
                    </div>
                </div>
            }
            <div className="grid grid--8 spacer--l">
                <div className="spacer--bottom-s">
                    <a href={link} style={{ color: 'initial' }}>
                        <h4>{data.Name}</h4>
                    </a>
                    <div>
                        <FollowButton data={data} onChange={props.onFollowChange} />
                    </div>
                </div>
                <p className="artist__bio text--details" dangerouslySetInnerHTML={{__html: data.Bio}}></p>
            </div>
        </React.Fragment>
    );
}

function ShowCell(props) {
    return (
        <div className="grid grid--6 spacer--bottom">
            <ShowVertical
                className="show__grid"
                cols={2}
                slider={false}
                {...props} />
        </div>
    )
}

const Show = forResource(_Show, Artcloud.url.vendor.marketplace.shows.getid);
export default Show;